import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {User} from '../../_models/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";


import {LoginHelper, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder} from "@angular/forms";
import {TrainingService} from "../../_services/training.service";
import {forkJoin} from "rxjs";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "trainingSummary-component",
  templateUrl: 'trainingSummary.component.html',
  styleUrls: ['./trainingSummary.component.scss'],
})

export class TrainingSummaryComponent implements OnInit {
  api = window.location.origin;
  items: any[];
  trainingId: number = null;
  trainings = [];
  tenantName: string;
  answers: any[];
  token = LoginHelper.getFileToken();
  users: User[];
  rowGroupMetadata = {};
  departments = {};
  answerData = {};
  isInviteVisible: boolean = false;


  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public trainingService: TrainingService) {
    this.departments[1] = 'HR';
    this.departments[2] = 'Sales';
    this.departments[3] = 'Marketing';
    this.departments[4] = 'IT';
    this.departments[5] = 'Audit';
    this.departments[6] = 'Client Srvice';
    this.departments[7] = 'Engineering';
    this.departments[8] = 'Operations';
    this.departments[9] = 'Field';
    this.departments[-1] = 'No Department';
  }


  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isInviteVisible = (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0
      || (currentUser.role & Role.KingAdmin) != 0
      || (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;

    forkJoin(this.trainingService.getAllTrainings(),
      this.trainingService.getTrainingResults(),
      this.userService.getAllShort()
    )
      .subscribe(data => {
        this.trainings = data[0];
        this.answers = data[1];
        this.users = data[2].filter(u => (u.role & (Role.Survey | Role.Vendor)) == 0 || this.trainings.find(a => (a.trainingUSers || []).find(u => u.userId == u.userId)));
        this.updateRowGroupMetaData();
        for(let i = 0; i < this.users.length; i++)
        {
          this.answerData[this.users[i].userId] = {};
          for(let q = 0; q< this.trainings.length; q++)
          {
            const list = [];
            this.answerData[this.users[i].userId][q] = list;
            const answered = this.answers.filter(a => a.userId == this.users[i].userId && a.trainingId == this.trainings[q].id);
            answered.forEach(a => {
                list.push({status: '#CBDFB8', date: a.date});
            });
            if (answered.length == 0)
            {
              if (this.trainings[q].trainingUsers.find(u => u.userId == this.users[i].userId))
              {
                list.push({status: '#eab18b', date: null});
              }
            else
              {
                list.push({status: '#adaaaa', date: null});
              }
            }
          }
        }
      });
  }

  getFullName(userId) {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return "";
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  updateRowGroupMetaData() {
    const data = this.users;
    this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        rowData.department = rowData.department || -1;
        let brand = rowData.department;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.department || ' ';
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }

  }

}
